import { FC } from 'react';
import MuiTableSortLabel from '@mui/material/TableSortLabel';
import { ITableSortLabelProps } from './types';

export const TableSortLabel: FC<ITableSortLabelProps> = props => <MuiTableSortLabel {...props} />;
